import { Controller } from "@hotwired/stimulus";
import Swal from "sweetalert2";
class ArregloErrores extends Error {
    constructor(errores) {
        super();
        this.errores = errores;
    }
}
const marcadorRegex = new RegExp('{.*?}', 'g');
// TODO arreglar casteos forzados
export default class default_1 extends Controller {
    get form() {
        if (this.element instanceof HTMLFormElement) {
            return this.element;
        }
        throw new Error("This controller's element is not an HTMLFormElement.");
    }
    get campoId() {
        return this.form.elements.namedItem("id");
    }
    get campoMensajeHacienda() {
        return this.form.elements.namedItem("mensajeHacienda");
    }
    get campoMensajePersonalizado() {
        return this.form.elements.namedItem("mensajePersonalizado");
    }
    get enviadores() {
        return Array.from(this.form.querySelectorAll("input[type=submit], button[type=submit], button:not([type])"));
    }
    prepararFormulario(evento) {
        const detalle = this.analizarDetalle(evento.detail);
        this.campoId.value = detalle.id.toString();
        this.campoMensajeHacienda.value = detalle.mensajeHacienda;
        this.campoMensajePersonalizado.value = detalle.mensajePersonalizado;
        this.campoMensajePersonalizado.setCustomValidity("");
        this.enviadoresCambiarEstado("habilitado");
    }
    limpiarFormulario() {
        this.campoId.value = "";
        this.campoMensajeHacienda.value = "";
        this.campoMensajePersonalizado.value = "";
        this.campoMensajePersonalizado.setCustomValidity("");
        this.enviadoresCambiarEstado("deshabilitado");
    }
    limpiarErrorMensajePersonalizado() {
        this.campoMensajePersonalizado.setCustomValidity("");
    }
    enviarFormulario() {
        if (!this.esFormularioValido() && false) {
            this.form.reportValidity();
            return;
        }
        const contenedorErrores = this.contenedorErroresTarget;
        contenedorErrores.innerHTML = "";
        const limpiar = (() => {
            this.enviadoresCambiarEstado("deshabilitado");
            const limpiarTextoTemporal = this.enviadoresTextoTemporal("Enviando...");
            return () => {
                limpiarTextoTemporal();
                this.enviadoresCambiarEstado("habilitado");
            };
        })();
        const form = this.form;
        fetch(form.action, {
            method: form.method,
            body: new FormData(form),
        })
            .then((respuesta) => respuesta.json())
            .then((json) => {
            if (json) {
                if ("errores" in json) {
                    throw new ArregloErrores(json["errores"]);
                }
                if ("mensaje" in json) {
                    Swal.fire({
                        title: "Actualización exitosa",
                        text: "¡El mensaje fue actualizado exitosamente!",
                        icon: "success",
                    });
                    this.dispatch("detalleActualizado", { bubbles: true });
                    return;
                }
            }
            throw new Error("El servidor devolvio una respuesta inesperada.");
        })
            .catch((error) => {
            if (error instanceof ArregloErrores) {
                const lista = document.createElement("ul");
                error.errores.forEach((e) => {
                    const item = document.createElement("li");
                    item.innerText = e;
                    lista.appendChild(item);
                });
                contenedorErrores.appendChild(lista);
            }
            else if (error instanceof Error) {
                contenedorErrores.innerText = error.message;
            }
            else {
                console.log(error);
                contenedorErrores.innerText = "Se presentó un problema inesperado.";
            }
        })
            .finally(limpiar);
    }
    esFormularioValido() {
        const campoMensajePersonalizado = this.campoMensajePersonalizado;
        const mensajeHacienda = this.campoMensajeHacienda.value;
        const mensajePersonalizado = campoMensajePersonalizado.value.trim();
        campoMensajePersonalizado.setCustomValidity("");
        if (mensajePersonalizado) {
            const marcadores = Array
                .from(mensajeHacienda.matchAll(marcadorRegex));
            if (marcadores.length > 0) {
                const marcadoresFaltantes = marcadores
                    .map((match) => {
                    if (mensajePersonalizado.includes(match[0])) {
                        return null;
                    }
                    return match[0];
                })
                    .filter((valor) => valor !== null);
                if (marcadoresFaltantes.length > 0) {
                    campoMensajePersonalizado.setCustomValidity("El mensaje personalizado debe incluir los marcadores incluidos"
                        + " en el mensaje de Hacienda."
                        + ` Marcadores faltantes: [${marcadoresFaltantes.join(", ")}].`);
                    return false;
                }
            }
        }
        return true;
    }
    analizarDetalle(datos) {
        return datos;
    }
    enviadoresCambiarEstado(estado) {
        let cambiarEstado;
        if (estado === "habilitado") {
            cambiarEstado = (e) => e.disabled = false;
        }
        else {
            cambiarEstado = (e) => e.disabled = true;
        }
        this.enviadores.forEach(cambiarEstado);
    }
    enviadoresTextoTemporal(texto) {
        const mapaMensajes = new WeakMap();
        this.enviadores.forEach((enviador) => {
            mapaMensajes.set(enviador, enviador.innerHTML);
            enviador.innerText = texto;
        });
        return () => {
            this.enviadores.forEach((enviador) => {
                const htmlOriginal = mapaMensajes.get(enviador);
                if (htmlOriginal !== undefined) {
                    enviador.innerHTML = htmlOriginal;
                }
            });
        };
    }
}
default_1.targets = ["contenedorErrores"];
//# sourceMappingURL=form_controller.js.map